import { KeyValueModel } from "model";
import { EnumIndFinal } from "model/enums/enum-ind-final";

export const IndFinalMock: KeyValueModel[] = [
    new KeyValueModel(EnumIndFinal.NORMAL, 'Não'),
    new KeyValueModel(EnumIndFinal.CONSUMIDOR_FINAL, 'Sim'),
]